import _ from 'lodash'

export default function isNullOrUndefined(n) {
  return _.isNull(n) || _.isUndefined(n)
}
